import { TEDirectSearchSuggest } from './te.class.directsearchsuggest';

export const opaccDirectSearchSuggestPlugin = new TEDirectSearchSuggest();
